<div [class.is-filtered]="isFiltered">
  <mat-form-field class="report-number-element">
    <mat-label>Filter</mat-label>
    <div matPrefix>
      <span #reportNumberAbbreviationEl>{{ reportNumberAbbreviation }}</span>
      <mat-select [formControl]="basicRegistration">
        <mat-option *ngFor="let basicRegistration of filters.basicRegistrations.data" [value]="basicRegistration.task_numbering">{{ basicRegistration.task_numbering }}</mat-option>
      </mat-select>
      <mat-select [formControl]="tileSelection">
        <mat-option *ngFor="let tile of filters.tiles.data" [value]="tile.id">{{ tile.name }}</mat-option>
      </mat-select>
    </div>
    <input (click)="$event.stopImmediatePropagation()" [formControl]="element" matInput type="number">
  </mat-form-field>
  <button (click)="clearFilterButton()" [class.show]="isFiltered" mat-icon-button type="button">
    <mat-icon>clear</mat-icon>
  </button>
</div>
